export var BlindScanStatus;
(function (BlindScanStatus) {
    BlindScanStatus["Canceled"] = "canceled";
    BlindScanStatus["Running"] = "running";
    BlindScanStatus["Done"] = "done";
})(BlindScanStatus || (BlindScanStatus = {}));
